import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import AboutSection from './components/AboutSection';
import ArticleCTASection from './components/ArticleCTASection';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Superbuy Spreadsheet',
  url: 'https://superbuyspread.click',
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67defc9f4dfae2c04004e8ea78b88107.png',
  description: 'The ultimate Superbuy Spreadsheet resource hub featuring product finds, shopping guides, and category databases for smarter product discovery.',
  foundingDate: '2025',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer support',
    url: 'https://kaspreadsheet.com',
  },
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <main>
        <Navbar />
        <HeroSection />
        <CategorySection />
        <AboutSection />
        <ArticleCTASection />
        <Footer />
      </main>
    </>
  );
}